<button type="button" [id]="'sc-button-'+id" class="btn"
        [attr.title]="title"
        (click)="onClickHandler($event)"
        [class]="type"
        [ngClass]="{ 'loading': loading, 'full-width': isFullWidth }"
        [disabled]="disabled">
    <span *ngIf="!loading" class="body" [innerHTML]="body"></span>
    <span *ngIf="loading" [ngClass]="loadingType" class="spinner loading sc-icon icon-loading"></span>
</button>